// Karten-Overlay-Daten pro Region (Route-Linie, Korridor-Umriss, Bereichs-
// Grenzen).
//
// Wave 14ed — KEINE gebuendelten Renndaten mehr.
//
// Frueher lagen hier route.geojson / corridor.geojson / navi-segments.geojson
// der 3-Peaks-Bike-Race-Route als `?raw`-Import im Bundle (~160 KB), damit sie
// der Service-Worker precached. Damit war die 3-Peaks-Route ein fester
// Bestandteil JEDER Installation — auch fuer einen frisch eingeladenen User,
// der mit dem Rennen nichts zu tun hat.
//
// User (2026-08-04): "wenn ich die app zum ersten mal installiere sollen gar
// keine offline komponenten da sein … keine 3 peaks route, nix!"
//
// Overlays kommen jetzt ausschliesslich vom Server, pro selbst gebautem
// Korridor: lib/corridorOverlays.ts holt sie ueber
// GET /api/corridors/region/:slug/overlays und cached sie in IndexedDB.
// MapView faellt hier nur noch auf "nichts zeichnen" zurueck.
//
// Die GeoJSON-Dateien bleiben im Repo (apps/rider/src/data/*.geojson) und
// werden weiter von scripts/gen-corridor-geojson.mjs erzeugt — sie werden
// nur nicht mehr importiert. Wer die Renn-Overlays zurueck will, baut den
// 3PBR-Korridor als normalen Self-Service-Korridor; dann liefert der Server
// exakt dieselben Overlays.

export interface RouteProps {
  stage: number;
  name: string;
}

export interface CorridorProps {
  km_per_side: number;
}

export interface NaviSegmentProps {
  id: string;
  idx: number;
  label: string;
}

/** Karten-Daten einer Region — die Map zeichnet die aktive Region. */
export interface RegionMapData {
  route: GeoJSON.FeatureCollection<GeoJSON.LineString, RouteProps>;
  corridor: GeoJSON.FeatureCollection<GeoJSON.Polygon | GeoJSON.MultiPolygon, CorridorProps>;
  naviSegments: GeoJSON.FeatureCollection<
    GeoJSON.Polygon | GeoJSON.MultiPolygon,
    NaviSegmentProps
  >;
}

function emptyFc<P>(): GeoJSON.FeatureCollection<any, P> {
  return { type: 'FeatureCollection', features: [] };
}

export const EMPTY_REGION_MAP_DATA: RegionMapData = {
  route: emptyFc<RouteProps>(),
  corridor: emptyFc<CorridorProps>(),
  naviSegments: emptyFc<NaviSegmentProps>(),
};

/**
 * Es gibt keine einkompilierten Overlays mehr — immer leer. Die Signatur
 * bleibt, damit MapView/style.ts unveraendert ihre Sources initialisieren
 * koennen; gefuellt werden sie von corridorOverlays (Server + IndexedDB).
 */
export function getRegionMapData(_region: string): RegionMapData {
  return EMPTY_REGION_MAP_DATA;
}
